<template>
  <div class="grid-view tab-change-charge">
    <query-change-charge
      ref="queryChangeCharge"
      identify="queryChangeCharge"
      view-source="tabChangeCharge"
      :state="searchConditionsState"
      :input-date-start="searchConditions.inputDateStart"
      :input-date-end="searchConditions.inputDateEnd"
      config-module="511"
      grid-config-module="191101"
      @showDetailClicked="showDetailHandler"
    >
      <div slot="operations">
        <el-button v-show="[3].includes(applicationStatus)" type="primary" no="1" @click="lookHandler">{{ this.$t('CargoMsg.Cargo_View') }}</el-button>
        <el-button v-show="[3].includes(applicationStatus)" type="primary" no="2" @click="copyHandler">{{ this.$t('CargoMsg.Cargo_Copy') }}</el-button>
        <el-button v-show="[3].includes(applicationStatus) && this.hasRevoke" type="danger" no="3" @click="revokeHandler">{{ this.$t('ChangeCharge.revoke') }}</el-button>
        <el-button v-show="(([0].includes(applicationStatus) || [4].includes(applicationStatus)) && this.hasJudgeDuty) || ([1].includes(applicationStatus) && this.hasBusinessAudit) || (applicationStatus === 2 && hasJudgeClosed)" type="danger" no="4" @click="returnHandler">{{ this.$t('ChangeCharge.return') }}</el-button>
        <el-button v-show="([0].includes(applicationStatus) || [4].includes(applicationStatus)) && this.hasJudgeDuty" type="primary" no="5" @click="judgeDutyHandler">{{ this.$t('ChangeCharge.judgeDuty') }}</el-button>
        <el-button v-show="[1].includes(applicationStatus) && this.hasBusinessAudit" type="primary" no="6" @click="businessAuditHandler">{{ this.$t('ChangeCharge.businessAudit') }}</el-button>
        <el-button v-show="[2].includes(applicationStatus) && this.hasJudgeClosed" type="primary" no="7" @click="judgeClosedHandler">{{ this.$t('ChangeCharge.judgeClosed') }}</el-button>
        <el-button type="primary" no="8" @click="toPrint">{{ $t('Payment.print') }}</el-button>
        <el-button v-show="[3].includes(applicationStatus)" type="primary" no="9" @click="exportHandler">{{ this.$t('ChangeCharge.exportDetail') }}</el-button>
      </div>
      <template v-slot:other>
        <el-form :inline="true" label-width="60px" label-position="left" style="margin-right: 15px;">
          <el-form-item :label="$t('ChangeCharge.dateCreated')" class="el-form-item-search">
            <el-row>
              <el-col :span="8">
                <el-form-item label-width="0">
                  <el-date-picker
                    v-model="searchConditions.inputDateStart"
                    type="date"
                    style="margin-right: 0px;"
                    :clearable="false"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    no="10"
                  /></el-form-item>
              </el-col>
              <el-col :span="2"><span>{{ $t('Billing.billingJob_dateTo') }}</span></el-col>
              <el-col :span="8">
                <el-form-item label-width="0">
                  <el-date-picker
                    v-model="searchConditions.inputDateEnd"
                    type="date"
                    clearable
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    no="11"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="0">
                  <el-checkbox v-model="allowTwoYearOutside" no="12">{{ $t('Billing.billingJob_lockCheckBoxDate') }}</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </template>
    </query-change-charge>
    <!-- 判责审核弹窗 -->
    <el-dialog
      :visible.sync="judgeDutyDialog.visible"
      :title="$t('ChangeCharge.judgeDuty')"
      :close-on-click-modal="false"
      :show-close="false"
      width="1000px"
    >

      <div class="section grid-wrapper">
        <div slot="operations">
          <div style="margin-bottom: 5px">
            <el-button type="primary" no="13" @click="responsibleHandler('1')">{{ this.$t('CargoMsg.Responsible') }}</el-button>
            <el-button type="primary" no="14" @click="responsibleHandler('0')">{{ this.$t('CargoMsg.No_Responsibility') }}</el-button>
          </div>
        </div>
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          config-module="191102"
          :row-data="judgeDutyDialog.rowData"
          min-height="300px"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" no="15" @click="judgeDutyConfirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="16" @click="dialogCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 商务审核弹窗 -->
    <el-dialog
      :visible.sync="businessAuditDialog.visible"
      :title="$t('CargoMsg.Cargo_Tips')"
      :close-on-click-modal="false"
      :show-close="false"
      width="280px"
    >
      <div class="app-main-inner-row" style="flex-direction: column;padding-bottom: 10px;">
        <span style="text-align: center;font-size: 14px;padding-bottom: 20px;">{{ $t('ChangeCharge.businessAuditMessage') }}</span>
        <el-radio-group v-model="businessAuditDialog.businessAuditResult" style="margin-left: 40px; padding-bottom: 20px;" no="17">
          <el-radio label="1">{{ $t('ChangeCharge.businessAuditAgree') }}</el-radio>
          <el-radio label="0">{{ $t('ChangeCharge.businessAuditRefuse') }}</el-radio>
        </el-radio-group>
        <el-input v-model="businessAuditDialog.businessAuditReason" :placeholder="$t('ChangeCharge.businessAuditReasonNotNull')" no="18" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" no="19" @click="businessAuditConfirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="20" @click="dialogCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 关账判定弹窗 -->
    <el-dialog
      :visible.sync="judgeClosedDialog.visible"
      :title="$t('ChangeCharge.tabJudgeClosed')"
      :close-on-click-modal="false"
      :show-close="false"
      width="330px"
    >
      <div class="main-content">
        <div style="width: fit-content">
          <div style="display: flex">
            <div class="section form-column" style="min-width: 310px">
              <el-form
                label-width="75px"
                style="margin: 20px;"
                label-position="left"
              >
                <div v-show="judgeClosedDialog.isJudgeClosed" style="margin: 20px">
                  <span style="text-align: center;font-size: 14px;padding-bottom: 20px;">{{ $t('ChangeCharge.judgeClosedMessage') }}</span>
                </div>
                <el-radio-group v-show="judgeClosedDialog.isJudgeClosed" v-model="judgeClosedDialog.judgeClosedResult" style="margin-left: 40px;" no="21">
                  <el-radio label="1">{{ $t('ChangeCharge.judgeClosedBefore') }}</el-radio>
                  <el-radio label="0">{{ $t('ChangeCharge.judgeClosedAfter') }}</el-radio>
                </el-radio-group>
                <el-form-item style="font-size: 14px; margin: 20px" :label="$t('CargoMsg.Cargo_FinancialDate')">
                  <div style="display: flex;">
                    <el-date-picker
                      v-model="judgeClosedDialog.accountingDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="flex: 1;width: 80px"
                      :clearable="false"
                      no="22"
                    />
                  </div>
                </el-form-item>
                <el-checkbox v-model="judgeClosedDialog.isJudgeClosed" style="margin: 20px" :label="$t('ChangeCharge.JudgeBeforeAndAfterAccountClosing')" no="23" />
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" no="24" @click="judgeClosedConfirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="25" @click="dialogCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 退回弹窗 -->
    <el-dialog
      :visible.sync="returnDialog.visible"
      :title="$t('CargoMsg.Cargo_Tips')"
      :close-on-click-modal="false"
      :show-close="false"
      width="300px"
    >
      <div class="app-main-inner-row" style="flex-direction: column;padding-bottom: 10px;">
        <span style="text-align: center;font-size: 14px;padding-bottom: 20px;">{{ $t('ChangeCharge.returnMessage') }}</span>
        <span style="text-align: center;font-size: 14px;padding-bottom: 20px;">{{ $t('ChangeCharge.returnMessageConfirm') }}</span>
        <el-input v-model="returnDialog.returnReason" :placeholder="$t('ChangeCharge.returnReasonNotNull')" no="26" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" no="27" @click="returnConfirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="28" @click="dialogCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 撤销申请弹窗 -->
    <el-dialog
      :visible.sync="revokeDialog.visible"
      :title="$t('CargoMsg.Cargo_Tips')"
      :close-on-click-modal="false"
      :show-close="false"
      width="300px"
    >
      <div class="app-main-inner-row" style="flex-direction: column;padding-bottom: 10px;">
        <span style="text-align: center;font-size: 14px;padding-bottom: 20px;">{{ $t('ChangeCharge.revokeMessageConfirm') }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" no="29" @click="revokeConfirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="30" @click="dialogCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 更改前后对比弹窗 -->
    <before-and-after-comparison-dialog
      v-if="beforeAndAfterComparisonDialog.visible"
      :visible.sync="beforeAndAfterComparisonDialog.visible"
      :change-reason="beforeAndAfterComparisonDialog.changeReason"
      :charge-before="beforeAndAfterComparisonDialog.chargeBefore"
      :charge-after="beforeAndAfterComparisonDialog.chargeAfter"
      :charge-original-profit="beforeAndAfterComparisonDialog.chargeOriginalProfit"
      :charge-change-profit="beforeAndAfterComparisonDialog.chargeChangeProfit"
      @onCancel="() => { beforeAndAfterComparisonDialog.visible = false }"
    />
    <!-- 打印弹窗 -->
    <cargo-template-select-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
    <change-charge-detail-dialog
      v-if="detailDialog.visible"
      :visible.sync="detailDialog.visible"
      :editable="detailDialog.editable"
      :source="detailDialog.source"
      :input-including-tax-unit-price="inputIncludingTaxUnitPrice"
      @close="detailDialog.visible=false"
      @returnCall="reloadData"
    />
  </div>
</template>

<script>
import queryChangeCharge from '@/views/cargo/v0/Clearing/components/query/queryChangeCharge'
import moment from 'moment'
import * as ChangeChargeConstant from '@/class/cargo/model/parameters/ChangeChargeConstant'
import { getLoading } from '@/utils/utilBaseElement'
import { updateChangeChargeState, getChangeCharge } from '@/api/clearing/changeCharge'
import StrUtils from '@/utils/StrUtils'
import beforeAndAfterComparisonDialog from '@/views/cargo/v0/Clearing/components/ChangeChargeVerify/beforeAndAfterComparisonDialog'
import CargoTemplateSelectDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import CargoAgGridAdvanceMultipleSelectEditor
  from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor/index'
import ColumnUtils from '@/utils/ColumnUtils'
import CustomLabelUtils from '@/utils/CustomLabelUtils'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import ChangeChargeDetailDialog from '@/views/cargo/v0/Clearing/components/ChangeChargeVerify/changeChargeDetailDialog'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import URL from '@/api/urlTranslator'
import { getToken } from '@/utils/auth'
import { submitDataByPost } from '@/utils/commonUtil'
import { getGridSelected } from '@/utils/agGrid'
import { CHANGE_CHARGE_STATES_ALL_CODES } from '@/class/cargo/model/parameters/ChangeChargeConstant'
import { checkAccountClosed } from '@/api/act/closingAccount'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'TabChangeCharge',
  components: { ChangeChargeDetailDialog, CargoTemplateSelectDialog, queryChangeCharge, beforeAndAfterComparisonDialog },
  props: {
    applicationStatus: { type: Number, default: 0 } // 申请进度:1=待判责审核;2=待商务审核;3=待关账判定;4=已生效;5=已拒绝;6=已撤销申请;7=待经理审核
  },
  data() {
    return {
      loading: false,
      searchConditions: {
        inputDateStart: moment().subtract(2, 'y').format('yyyy-MM-DD'), // 付款申请日期
        inputDateEnd: ''
      },
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      applyChangeChargeTab: 0, // 审核流程配置参数
      inputIncludingTaxUnitPrice: 0, // 单价是否含税
      hasJudgeDuty: false, // 是否判责审核权限
      hasBusinessAudit: false, // 是否商务审核权限
      hasJudgeClosed: false, // 是否关账判定权限
      hasRevoke: false, // 是否撤销申请权限
      allowTwoYearOutside: false,
      // 判责审核弹窗
      judgeDutyDialog: {
        visible: false,
        judgeDutyResult: '1' // 判责审核结果
      },
      // 商务审核弹窗
      businessAuditDialog: {
        visible: false,
        businessAuditResult: '1', // 商务审核结果
        businessAuditReason: '' // 拒绝原因
      },
      // 关账判定弹窗
      judgeClosedDialog: {
        visible: false,
        judgeClosedResult: '1', // 关账判定结果
        accountingDate: new Date(), // 财务日期
        isJudgeClosed: false // 判断关账前后
      },
      // 撤销申请
      revokeDialog: {
        visible: false
      },
      // 退回弹窗
      returnDialog: {
        visible: false,
        returnReason: '' // 退回原因
      },
      templateSelectorDialog: { // 打印
        visible: false,
        cxt: null,
        category: 'CHANGE_CHARGE',
        data: {
          CHANGE_CHARGE_LIST_UUID: []
        }
      },
      detailDialog: { // 更改原因
        visible: false,
        editable: false,
        source: []
      },
      // 更改前后对比
      beforeAndAfterComparisonDialog: {
        visible: false,
        changeReason: '', // 更改原因
        chargeBefore: [], // 修改前
        chargeAfter: [], // 修改后,
        chargeOriginalProfit: [], // 整票预估利润：修改前
        chargeChangeProfit: [] // 整票预估利润：修改后
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridSelectEditor,
          CargoAgGridAdvanceMultipleSelectEditor
        },
        onRowClicked: this.rowClicked
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        { headerName: this.$t('ChangeCharge.jobNo'), field: 'jobNo',
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: true,
              routeName: 'FinanceManage',
              routeParamKeys: { jobNo: 'jobNo' },
              routeTitle: this.$t('Clearing.FinancialAudit'),
              routePermissions: ['module_ACVerify'],
              extraRouteParams: {},
              printMethod: this.toSearchTemplate
            }
          }, width: 140 },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          initialWidth: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        { headerName: this.$t('ChangeCharge.actionType'), field: 'actionType',
          colId: 'actionType',
          cellRenderer: (params) => {
            return ColumnUtils.changeChargeActionTypeLabFun(params.value)
          }, width: 90 },
        {
          headerName: this.$t('ChangeCharge.JudgmentResult'),
          colId: 'judgeDutyResult',
          field: 'judgeDutyResult',
          cellRenderer: (params) => {
            return ColumnUtils.changeChargeJudgedutyLabFun(params.value)
          }, width: 150,
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = [... ChangeChargeConstant.CHANGE_CHARGE_JUDGEDUTY]
            return {
              selectProps: {
                tagValue: 'code',
                tagName: 'chineseName',
                staticOptions
              }
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReasonForJudgment'),
          hide: this.applicationStatus !== 4, suppressColumnsToolPanel: this.applicationStatus !== 4,
          colId: 'reasonForJudgment',
          field: 'reasonForJudgment',
          cellRenderer: (params) => {
            return ColumnUtils.resolveMultipleColumnLabel(TYPE_NAMES.basic_data_ReasonForJudgment, 'uuid', params.value, 'reason')
          },
          editable: true,
          cellEditor: 'CargoAgGridAdvanceMultipleSelectEditor',
          cellEditorParams: {
            selectProps: {
              multiple: true,
              selectType: TYPE_NAMES.basic_data_ReasonForJudgment,
              tagName: 'reason',
              tagValue: 'uuid'
            }
          }
        },
        {
          headerName: this.$t('ChangeCharge.changeReason'),
          colId: 'changeReason',
          field: 'changeReason'
        },
        {
          headerName: this.$t('FinanceManage.charge_settleAccountsTo'),
          colId: 'accountId',
          field: 'accountId',
          initialWidth: 180,
          valueFormatter: (params) => {
            return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0')
          }
        },
        { headerName: this.$t('FinanceManage.charge_invoiceHeader'), field: 'invoiceTitle', width: 140 },
        {
          headerName: this.$t('FinanceManage.charge_somesticOrInternational'),
          colId: 'oversea',
          field: 'oversea',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_drawABillOrNot'),
          colId: 'needInvoice',
          field: 'needInvoice',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }
        },
        {
          headerName: this.$t('Payment.controlledOrNot'),
          colId: 'controlled',
          field: 'controlled',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_currency'), colId: 'currency', field: 'currency', initialWidth: 180
        },
        {
          headerName: this.$t('FinanceManage.charge_exchangeRate'),
          colId: 'exchangeRate',
          field: 'exchangeRate',
          initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000000')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_unit'), colId: 'measure', field: 'measure', initialWidth: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_quantity'), colId: 'quantity', field: 'quantity', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentReceiveMethod'), field: 'receivable', width: 100, colId: 'receivable',
          valueFormatter: params => {
            return CommonState.getNameByCode(ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE, params.value ? 1 : 0)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'), colId: 'unitRate', field: 'unitRate', initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxIncludedPrice'), colId: 'amount', field: 'amount', initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxExcludedPrice'),
          colId: 'excludingTaxAmount1',
          field: 'excludingTaxAmount',
          initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxRate'), colId: 'taxRate', field: 'taxRate', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPriceIncludeTax'),
          colId: 'unitPriceIncludeTax',
          field: 'unitPriceIncludeTax',
          initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxAmount'), colId: 'taxAmount', field: 'taxAmount', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_remarks'), colId: 'chargeRemarks', field: 'chargeRemarks', initialWidth: 180
        },
        {
          headerName: this.$t('FinanceManage.charge_contactPerson'),
          colId: 'contactPerson',
          field: 'contactPerson',
          initialWidth: 180
        }
      ],
      rowData: [],
      isDirectModify: false // 更改费用审核费用调整模式 （1=调整模式，默认；2=直接更改）
    }
  },
  computed: {
    searchConditionsState() {
      switch (this.applicationStatus) {
        case 0: return [ChangeChargeConstant.CHANGE_CHARGE_AWAIT_JUDGEDUTY.code]
        case 1: return [ChangeChargeConstant.CHANGE_CHARGE_AWAIT_BUSINESSAUDIT.code]
        case 2: return [ChangeChargeConstant.CHANGE_CHARGE_AWAIT_JUDGECLOSED.code]
        case 3: return CHANGE_CHARGE_STATES_ALL_CODES
        case 4: return [ChangeChargeConstant.CHANGE_CHARGE_MANAGER_REVIEW.code]
        default: return []
      }
    }
  },
  watch: {
    allowTwoYearOutside(val) {
      if (val) {
        this.$confirm(this.$t('Billing.billingJob_unlockBillPaymentDateQuery'), this.$t('Message.Prompt'), { type: 'warning' }).catch(err => {
          console.log(err)
          this.allowTwoYearOutside = false
        })
      } else {
        this.searchConditions.inputDateStart = moment().subtract(2, 'y').format('yyyy-MM-DD')
      }
    },
    'judgeClosedDialog.visible': function(val) {
      if (val) {
        const isJudgeClosed = LocalStorageUtils.getConfiguration('judgeClosedDialog.isJudgeClosed')
        if (isJudgeClosed) {
          this.judgeClosedDialog.isJudgeClosed = isJudgeClosed
        } else {
          // 客户未自定义情况下淳宏默认不勾选，锦昶默认为勾选
          if (this.$store.getters.tenantId === 11699) {
            this.judgeClosedDialog.isJudgeClosed = true
          }
          if (this.$store.getters.tenantId === 253) {
            this.judgeClosedDialog.isJudgeClosed = false
          }
        }
      } else {
        LocalStorageUtils.setConfiguration('judgeClosedDialog.isJudgeClosed', this.judgeClosedDialog.isJudgeClosed)
      }
    }
  },
  async created() {
    this.hasJudgeDuty = this.$checkPermission(['button_ChangeChargeVerify_btnJudgeDuty'])
    this.hasBusinessAudit = this.$checkPermission(['button_ChangeChargeVerify_btnBusinessAudit'])
    this.hasJudgeClosed = this.$checkPermission(['button_ChangeChargeVerify_btnJudgeClosed'])
    this.hasRevoke = this.$checkPermission(['button_ChangeChargeVerify_btnRevoke'])
    await cache.load(cacheName.CONFIG)
    this.applyChangeChargeTab = Number(cache.config.get('applyChangeChargeTab'))
    // CARGO-4980 单价是否含税
    this.inputIncludingTaxUnitPrice = parseInt(cache.config.get('InputIncludingTaxUnitPrice'))
    // CARGO-24840，申请更改费用/申请删除费用时直接在原费用上做调整
    this.isDirectModify = parseInt(cache.config.get('ChangeChargeJudgeClosedType')) === 2
  },
  methods: {
    // 重新加载列表数据
    reloadData() {
      this.$refs.queryChangeCharge.toQueryChangeChargeList()
    },
    // 打印按钮触发事件
    toPrint() {
      const chooseRows = this.$refs.queryChangeCharge.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectChargeApplyData'))
        return
      }
      const params = {}
      const keys = []
      for (const changeCharge of chooseRows) {
        if (changeCharge.uuid && keys.indexOf(changeCharge.uuid) < 0) {
          keys.push(changeCharge.uuid)
        }
      }
      params.CHANGE_CHARGE_LIST_UUID = keys
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.category = 'CHANGE_CHARGE'
      this.templateSelectorDialog.visible = true
    },
    exportHandler() {
      const chooseRows = this.$refs.queryChangeCharge.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExportChargeDetailData'))
        return
      }
      if (chooseRows && chooseRows.length > 5000) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BeyondMaxExportChargeDetailData'))
        return
      }
      const keys = []
      for (const changeCharge of chooseRows) {
        if (changeCharge.uuid && keys.indexOf(changeCharge.uuid) < 0) {
          keys.push(changeCharge.uuid)
        }
      }
      submitDataByPost(URL.act.changeCharge.exportChangeChargeDetail, {
        sessionId: getToken(),
        uuids: keys.join(',')
      })
      this.reloadData()
    },
    // 更改前后对比
    showDetailHandler(changeCharge) {
      if (!changeCharge || StrUtils.isEmpty(changeCharge.uuid)) return
      if (changeCharge.branchId !== this.$store.getters.currentOfficeId && !JobUtils.checkHierarchicalDetailFinancial(changeCharge.branchId)) {
        this.$message.warning(this.$t('Message.NoHasViewRole'))
        return
      }
      const requestBody = { changeChargeKey: changeCharge.uuid, branchId: this.$store.getters.currentOfficeId }
      this.loading = getLoading()
      console.log('getChangeCharge', requestBody)
      getChangeCharge(requestBody).then(res => {
        const changeCharge = res.data
        this.beforeAndAfterComparisonDialog.chargeBefore = []
        if (changeCharge.actionType === 0) this.beforeAndAfterComparisonDialog.chargeBefore.push(changeCharge.chargeOriginal)
        this.beforeAndAfterComparisonDialog.chargeAfter = []
        this.beforeAndAfterComparisonDialog.chargeAfter.push(changeCharge.chargeChange)
        this.beforeAndAfterComparisonDialog.changeReason = changeCharge.changeReason
        // 整票预估利润
        this.beforeAndAfterComparisonDialog.chargeOriginalProfit = []
        this.beforeAndAfterComparisonDialog.chargeOriginalProfit = changeCharge.chargeOriginalProfit
        this.beforeAndAfterComparisonDialog.chargeChangeProfit = []
        this.beforeAndAfterComparisonDialog.chargeChangeProfit = changeCharge.chargeChangeProfit
        this.beforeAndAfterComparisonDialog.visible = true
      }).finally(() => {
        this.loading.close()
      })
    },
    // 判责审核
    judgeDutyHandler() {
      const selections = this.$refs.queryChangeCharge.getSelections()
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecord'))
        return
      }
      this.judgeDutyDialog.judgeDutyResult = '1'
      this.judgeDutyDialog.rowData = selections
      this.judgeDutyDialog.visible = true
    },
    judgeDutyConfirm() {
      const requestBody = { action: this.applicationStatus === 0 ? 'judgeDuty' : 'managerReview' }
      this.doUpdateChangeChargeState(requestBody)
    },
    doUpdateChangeChargeState(param) {
      const selections = this.$refs.queryChangeCharge.getSelections()
      if (selections.length === 0) {
        this.dialogCancel()
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecord'))
        return
      }
      const keys = []
      const judgeDutyMap = {}
      for (const changeCharge of selections) {
        if (param.action === 'revoke') { // 撤销申请、1=待判责审核、2=待商务审核
          if ([this.applyChangeChargeTab === 0 ? 1 : 2].includes(changeCharge.state)) { // 审批
            keys.push(changeCharge.uuid)
          }
        } else {
          keys.push(changeCharge.uuid)
          if (param.action === 'judgeDuty' || param.action === 'managerReview') {
            if (StrUtils.isEmpty(changeCharge.judgeDutyResult)) {
              this.$message.warning(this.$t('ChangeCharge.judgeDutyResult') + this.$t('queryJob.CannotBeEmpty'))
              return
            }
            // 判责原因只用于代经理审核
            if (param.action === 'managerReview') {
              if (StrUtils.isEmpty(changeCharge.reasonForJudgment)) {
                this.$message.warning(this.$t('CargoMsg.Cargo_ReasonForJudgment') + this.$t('queryJob.CannotBeEmpty'))
                return
              }
            }
            const map = {
              judgeDutyResult: changeCharge.judgeDutyResult,
              reasonForJudgment: param.action === 'judgeDuty' ? '' : changeCharge.reasonForJudgment.join(',')
            }
            judgeDutyMap[changeCharge.uuid] = map
          }
        }
      }
      if (keys.length === 0) return
      // 当前状态
      param.state = selections[0].state
      param.uuids = keys
      if (param.action === 'judgeDuty' || param.action === 'managerReview') {
        param.judgeDutyMap = judgeDutyMap
      }
      param.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      console.log('updateChangeChargeState', param)
      updateChangeChargeState(param).then(res => {
        if (this.isDirectModify && res.data && res.data.length > 0) {
          let changeChargeNos = ''
          for (const changeCharge of res.data) {
            changeChargeNos += (StrUtils.isEmpty(changeChargeNos) ? '' : '/') + changeCharge.changeChargeNo
          }
          this.$message.warning(this.$t('CargoMsg.Cargo_ChangeChargeChanged', [changeChargeNos]))
        } else {
          this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
        }
        // 刷新
        this.reloadData()
      }).finally(() => {
        this.loading.close()
        this.dialogCancel()
      })
    },
    dialogCancel() {
      this.judgeDutyDialog.visible = false
      this.businessAuditDialog.visible = false
      this.judgeClosedDialog.visible = false
      this.returnDialog.visible = false
      this.revokeDialog.visible = false
    },
    // 商务审核
    businessAuditHandler() {
      const selections = this.$refs.queryChangeCharge.getSelections()
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecord'))
        return
      }
      this.businessAuditDialog.businessAuditResult = '1'
      this.businessAuditDialog.businessAuditReason = ''
      this.businessAuditDialog.visible = true
    },
    businessAuditConfirm() {
      if (this.businessAuditDialog.businessAuditResult === '0' && StrUtils.isEmpty(this.businessAuditDialog.businessAuditReason)) {
        this.$message.warning(this.$t('ChangeCharge.businessAuditReasonNotNull'))
        return
      }
      const requestBody = { action: 'businessAudit', businessAuditResult: this.businessAuditDialog.businessAuditResult, businessAuditReason: this.businessAuditDialog.businessAuditReason }
      this.doUpdateChangeChargeState(requestBody)
    },
    // 关账判定
    judgeClosedHandler() {
      const selections = this.$refs.queryChangeCharge.getSelections()
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecord'))
        return
      }
      this.judgeClosedDialog.judgeClosedResult = '1'
      this.judgeClosedDialog.visible = true
    },
    async judgeClosedConfirm() {
      const judgeClosedResult = this.judgeClosedDialog.isJudgeClosed ? this.judgeClosedDialog.judgeClosedResult : ''
      const accountingDate = this.judgeClosedDialog.accountingDate
      if (!accountingDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_FinancialDateCheckNull'))
        return
      }
      const res = await checkAccountClosed({ branchId: this.$store.getters.currentOfficeId, closeAccountDate: accountingDate })
      if (res.data) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CloseAccountTips2'))
        return
      }
      const requestBody = { action: 'judgeClosed', judgeClosedResult: judgeClosedResult, accountingDate: accountingDate }
      this.doUpdateChangeChargeState(requestBody)
    },
    // 退回
    returnHandler() {
      const selections = this.$refs.queryChangeCharge.getSelections()
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecord'))
        return
      }
      this.returnDialog.returnReason = ''
      this.returnDialog.visible = true
    },
    returnConfirm() {
      if (StrUtils.isEmpty(this.returnDialog.returnReason)) {
        this.$message.warning(this.$t('ChangeCharge.returnReasonNotNull'))
        return
      }
      const requestBody = { action: 'return', returnReason: this.returnDialog.returnReason }
      this.doUpdateChangeChargeState(requestBody)
    },
    // 撤销申请
    revokeHandler() {
      const selections = this.$refs.queryChangeCharge.getSelections()
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecord'))
        return
      }
      for (const changeCharge of selections) {
        if (![1].includes(changeCharge.state)) {
          this.$message.warning(this.$t('ChangeCharge.revokeMessage'))
          return
        }
      }
      this.revokeDialog.visible = true
    },
    revokeConfirm() {
      const requestBody = { action: 'revoke' }
      this.doUpdateChangeChargeState(requestBody)
    },
    lookHandler() {
      const selections = this.$refs.queryChangeCharge.getSelections()
      if (!selections || selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecord'))
        return
      }
      this.detailDialog.editable = false
      this.detailDialog.source = selections
      this.detailDialog.visible = true
    },
    copyHandler() {
      const selections = this.$refs.queryChangeCharge.getSelections()
      // 只能复制已拒绝的申请单
      if (!selections || selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecord'))
        return
      }
      for (const selection of selections) {
        if (selection.state !== 5) {
          this.$message.warning(this.$t('ChangeCharge.OnlyRejectedApplicationFormsCanBeCopied'))
          return
        }
      }
      this.detailDialog.editable = true
      this.detailDialog.source = selections
      this.detailDialog.visible = true
    },
    responsibleHandler(isResponsible) {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecord'))
        return
      }
      chooseRows.forEach(row => {
        row.judgeDutyResult = isResponsible
      })
      // gird 刷新
      this.gridOptions.api.refreshCells({ force: true })
    }
  }
}
</script>

<style lang="scss">
.tab-change-charge {
  .el-form-item-search {
    margin-right: 15px;
    .el-form-item__label {
      padding-right: 5px;
      font-size: 13px !important;
    }
    .el-form-item__content {
      .el-checkbox {
        .el-checkbox__label {
          font-size: 13px !important;
          padding-left: 2px;
        }
      }
      .el-input {
        width: 110px;
      }
      .el-input__inner {
        padding-left: 20px !important;
        padding-right: 5px !important;
        width: 110px;
      }
    }
  }
}
</style>
